module.exports = __webpack_public_path__ + "img/UTANAS-3.b8929fae.jpg";